





























import {Component, Inject, Prop, Vue} from 'vue-property-decorator'
import {AppUtilsModel} from "@/plugins/app-utils";

@Component
export default class PhoneNumberInput extends Vue {
    @Prop({ type: String, required: true }) id: string | undefined;
    @Prop({ type: String, required: true }) feedbackId: string | undefined;
    @Prop({ type: Boolean }) state: boolean | null | undefined;
    @Prop({ type: String, required: false }) validateRule: string | undefined;
    @Prop({ type: String, required: false }) displayName: string | undefined;
    @Prop({ type: String, required: true }) phoneValue: string | null | undefined;

    @Inject() readonly $validator!: any;

    formattedPhoneValue: string | null = null;

    get inputElement(): HTMLInputElement {
        const inputComponent = this.$refs.phoneNumberInput as Vue;
        return inputComponent.$el as HTMLInputElement;
    }

    created() {
        this.formattedPhoneValue = this.phoneValue!;
        this.updateValue(true);
    }

    onChange(event) {
        let cursorPosition = this.inputElement.selectionStart || 0;
        cursorPosition -= Math.min(this.$helpers.isExists(this.formattedPhoneValue) ? this.formattedPhoneValue!.length : 0, AppUtilsModel.phoneNumberMaxLength + 5);

        this.updateValue();

        cursorPosition += this.$helpers.isExists(this.formattedPhoneValue) ? this.formattedPhoneValue!.length : 0;

        this.$nextTick(() => {
            this.inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
    }

    updateValue(isInit = false) {
        const phoneNumberResult = this.$appUtils.formatAdditionalPhoneNumber(this.formattedPhoneValue, isInit);

        this.formattedPhoneValue = phoneNumberResult.displayValue;
        this.$emit('update:phoneValue', phoneNumberResult.phoneNumber);
    }
}
